import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import Button from 'components/util/Button'
import ResponsiveImage from 'components/util/ResponsiveImage'
import PropTypes from 'prop-types'
import styles from './_syncsLanding.css'

import mobileScreen from 'images/landing/china/sync/screen/mobile.png'
import desktopScreen from 'images/landing/china/sync/screen/desktop.png'
const screens = {
  src: mobileScreen,
  large: desktopScreen,
}

function Syncs () {
  return (
    <div className={styles.syncsWrapper}>
      <div className={styles.syncs}>
        <div className={styles.content}>
          <Title color="black">从Under Armour智能运动鞋同步数据</Title>
          <Caption color="black">无论是否带上手机，皆可自动追踪数据，如距离、踏频、步幅。</Caption>
          <Button
            className={styles.callToAction}
            size="medium"
            type="default"
            onClick={() => { window.location.href = 'https://www.underarmour.cn/Activity/HOVR?cid=MMF%7CREF%7CMMFitness%7CSite%7Chomepage%7CHOVR' }}
          >了解更多</Button>
        </div>
        <div className={styles.screen}>
          <ResponsiveImage {...screens} />
        </div>
      </div>
    </div>
  )
}

Syncs.propTypes = {
  site: PropTypes.object,
}

export default Syncs
